import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { JsaPaper } from './jsaPaper.interface';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root'
  })

export class JsaPaperService {
  private apiUrl = `${environment.apiConfig.uri}/jsapaper`;
  private apiUrlSearch = `${environment.apiConfig.uri}/jsapaper/search`;
  private apiUrlExport = `${environment.apiConfig.uri}/jsapaper/export`;
  
  constructor(private http: HttpClient) {
  }

    createJsaPaper(newJsaPaper: FormData): Observable<any> {
        return this.http.post(this.apiUrl, newJsaPaper);
      }
    
      
    searchJsaPaperReport(office: string, startDate: Date, endDate: Date): Observable<any> {
      const params = new HttpParams()
          .set('office', office)
          .set('startDate', startDate.toISOString())
          .set('endDate', endDate.toISOString());
      return this.http.get(this.apiUrlSearch, { params });
  }

  exportJsaPaperExcel(): Observable<Blob> {
    return this.http.get(this.apiUrlExport, {
        responseType: 'blob'
    })
  }
}